import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const Title = styled('div')`
  font-weight: 700;
  font-size: 14px;
  color: ${theme.palette.secondary.main};
  display: flex;
  align-items: center;
  justify-content: space-between;

  .year {
    font-weight: 400;
    font-size: 12px;
  }
`;

export const Amount = styled('div')`
  font-weight: 700;
  font-size: 18px;
  color: ${theme.palette.text.dark};
`;

export const Trend = styled('div')`
  font-size: 14px;
  color: ${theme.palette.secondary.main};

  .percent {
    font-weight: 700;
    margin-right: 4px;

    &.red {
      color: ${theme.palette.error.main};
    }

    &.green {
      color: ${theme.palette.success.main};
    }
  }
`;
